import { SelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { EntityType } from '@/modules/entities/types/EntityType';

import { DirectHoldingsGroupVariant } from '../../EstateDirectHoldings.types';

export interface AddNewHoldingsGroupFormShape {
  type: EntityType | null;
  name: string | null;
}

export const INDIVIDUAL_HOLDINGS_GROUP_TYPE_OPTIONS: SelectInputOption[] = [
  { value: 'individual-account', display: 'Personal assets and liabilities' },
  { value: 'retirement-account', display: 'Retirement accounts' },
  { value: 'insurance-account', display: 'Life insurance policies' },
];

export const JOINT_HOLDINGS_GROUP_TYPE_OPTIONS: SelectInputOption[] = [
  { value: 'joint-account', display: 'Joint account' },
];

export const OTHER_HOLDINGS_GROUP_TYPE_OPTIONS: SelectInputOption[] = [
  { value: 'custodial-account', display: 'UGMA/UTMA accounts' },
  { value: 'qualified-tuition-account', display: '529 plans' },
];

export const ADD_NEW_HOLDINGS_OPTIONS_BY_VARIANT: Record<
  DirectHoldingsGroupVariant,
  SelectInputOption[]
> = {
  individual: INDIVIDUAL_HOLDINGS_GROUP_TYPE_OPTIONS,
  joint: JOINT_HOLDINGS_GROUP_TYPE_OPTIONS,
  other: OTHER_HOLDINGS_GROUP_TYPE_OPTIONS,
};
